"use strict";

/**
 * Get cookie value by cookie name from browser
 * @param {string} cookieName - name of the cookie
 * @returns {string} cookie value of the found cookie name
 */
function getCookie(cookieName) {
    var name = cookieName + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var cookieArray = decodedCookie.split(";");
    for (var i = 0; i < cookieArray.length; i++) {
        var cookieItem = cookieArray[i];
        while (cookieItem.charAt(0) === " ") {
            cookieItem = cookieItem.substring(1);
        }
        if (cookieItem.indexOf(name) === 0) {
            return cookieItem.substring(name.length, cookieItem.length);
        }
    }
    return "";
}

function setCookie(cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + (exdays*24*60*60*1000));
    var expires = "expires="+ d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

/**
 * Updates the product tile image when hovering over a swatch color
 */
function updateProductTileSwatchImage() {
    $(".js-swatch-update").off("mouseenter").on("mouseenter", function () {
        var $this = $(this);

        if ($this.closest(".set-item")) { return; }

        var productTileImageElement = $this.closest(".product-tile").find(".tile-image");
        var productTileImageClone = $this.closest(".product-tile").find(".js-image-clone");
        var defaultTileImage = $(productTileImageElement).attr("srcset");
        var swatchImageSrc = $this.data("js-product-image-source");

        if (productTileImageClone.length) {
            productTileImageElement = productTileImageClone;
            defaultTileImage = $(productTileImageClone).attr("srcset");
        }

        $(productTileImageElement).attr("srcset", swatchImageSrc);

        $this.off("mouseleave").on("mouseleave", function () {
            $(productTileImageElement).attr("srcset", defaultTileImage);
        });
    });
}

module.exports = {
    setBreacrumbCookie: function () {
        $(".c-product-tile a").on("click", function (e) {
            e.preventDefault();

            var $this = $(this);
            var $searchHeader = $(".m-grid-results-header");
            var $product = $this.parents(".product");
            var cid = null;
            var pid = null;
            var breadCrumb = null;

            if ($searchHeader.length > 0 && $searchHeader.data("cid")) {
                cid = $searchHeader.data("cid");
            }
            if ($product.length > 0 && $product.data("pid")) {
                pid = $product.data("pid");
            }
            var breadCrumbCookie = getCookie("breadcrumbs");

            if (cid && pid) {
                if (breadCrumbCookie) {
                    breadCrumb = JSON.parse(breadCrumbCookie.replace(/\|/g, ","));
                    var keys = Object.keys(breadCrumb);
                    if (keys.length > 50) {
                        delete breadCrumb[keys[0]];
                    }
                    breadCrumb[pid] = cid;
                    setCookie("breadcrumbs", JSON.stringify(breadCrumb).replace(/,/g, "|"), 30);
                } else {
                    var breadCrumbObj = {};
                    breadCrumbObj[pid] = cid;
                    setCookie("breadcrumbs", JSON.stringify(breadCrumbObj).replace(/,/g, "|"), 30);
                }
            }
            if (!cid && pid) {
                if (breadCrumbCookie) {
                    breadCrumb = JSON.parse(breadCrumbCookie.replace(/\|/g, ","));
                    if (breadCrumb[pid]) {
                        delete breadCrumb[pid];
                        setCookie("breadcrumbs", JSON.stringify(breadCrumb).replace(/,/g, "|"), 30);
                    }
                }
            }

            if ($this.attr("target") === "_blank" && $this.attr("rel") === "noopener") {
                window.open($this.attr("href"), "_blank", "noopener");
            } else if (e.which == 2) {
                window.open($this.attr("href"), "_blank");
            } else {
                window.location = $this.attr("href");
            }
        });
    },
    updateProductTileSwatchImage : updateProductTileSwatchImage
};
